import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { IconButton, Input, Dropdown, IOption } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { BufferRadiusInputContainer } from "./styled";

import { useGeometrySelection } from "../../../../hooks/geometrySelection/useGeometrySelection";

export const BufferRadiusInput: FC = () => {
  const { t } = useTranslation("common");
  const [value, setValue] = useState<string>("");
  const [{ settings }, setGeometrySelection] = useGeometrySelection();

  const dropdownOptions = useMemo(
    () => [
      { text: t("meter"), value: "1" },
      { text: t("kilometer"), value: "1000" },
      { text: t("feet"), value: "0.3048" },
      { text: t("miles"), value: "1609.34" },
    ],
    [t],
  );

  const onUpdateValue = useCallback(
    (inputValue: string) => {
      setGeometrySelection({
        settings: {
          ...settings,
          bufferRadius: inputValue,
        },
      });
    },
    [settings, setGeometrySelection],
  );

  const onUpdateMultiplier = useCallback(
    (inputValue: string) => {
      setGeometrySelection({
        settings: {
          ...settings,
          bufferMultiplier: inputValue,
        },
      });
    },
    [settings, setGeometrySelection],
  );

  useEffect(() => {
    setValue(settings?.bufferRadius);
  }, [settings?.bufferRadius]);

  return (
    <BufferRadiusInputContainer>
      <Input
        id={"buffer-radius-input"}
        type={"number"}
        width={"7rem"}
        value={value}
        onChange={e => {
          setValue(+e.target.value < 0 ? `${+e.target.value * -1}` : e.target.value);
        }}
        onKeyDown={e => e.code === "Enter" && onUpdateValue(value)}
      >
        <IconButton kind={"close"} onClick={() => onUpdateValue("")} />
      </Input>
      <Dropdown
        width="5.5rem"
        style={{ marginLeft: "-1px" }}
        zIndex={100}
        value={settings?.bufferMultiplier}
        options={dropdownOptions}
        onChange={(item: IOption[]) => onUpdateMultiplier(item[0].value)}
      />
    </BufferRadiusInputContainer>
  );
};
